import { EventEmitter, Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { constant } from '../../app.constants';
import { ParentService } from '../../pages/A2-utils/ParentClass/ParentService';
import { ResponseInterface } from '../interfaces/response.interface';
import { IServiceProvider, MergeServiceProviderRequest, ServiceProviderInterface } from '../interfaces/service-provider.interface';

@Injectable()
export class ServiceProviderService extends ParentService {
  serviceProviderSelected$ = new EventEmitter<ServiceProviderInterface>();
  saveOnSuccessfull$ = new EventEmitter<boolean>();
  newServiceProvider$ = new EventEmitter<boolean>(null);
  private serviceProvId = new BehaviorSubject<number>(null);
  serviceProvId$ = this.serviceProvId.asObservable();

  private dataServiceProviders = new BehaviorSubject<ServiceProviderInterface | null>(null);
  dataServiceProviders$ = this.dataServiceProviders.asObservable();

  private readonly serviceProviders = new BehaviorSubject<IServiceProvider[]>([]);
  serviceProviders$ = this.serviceProviders.asObservable();

  private resetMergeSelectionSource = new BehaviorSubject<boolean>(false);
  resetMergeSelection$ = this.resetMergeSelectionSource.asObservable();

  private readonly closeModalMergeServiProviders = new BehaviorSubject<{ isClose: boolean, refreshGrid: boolean }>
    ({ isClose: false, refreshGrid: false, });
   closeModalMergeServiProviders$ = this.closeModalMergeServiProviders.asObservable();

  private modalClosedSource = new BehaviorSubject<boolean>(false);
  modalClosed$ = this.modalClosedSource.asObservable();

  constructor(private _http: Http) {
    super();
  }

  get(): Observable<ServiceProviderInterface[]> {
    return this._http.get(constant.URL_SERVICE_PROVIDER, this.getHeader()).pipe(
      map((response: any) => response.json() as ServiceProviderInterface[])
    );
  }

  getByPtr(filter: String): Observable<ServiceProviderInterface[]> {
    return this._http.post(constant.URL_SERVICE_PROVIDER_SEARCH, { filter } , this.getHeader()).pipe(
      map((response: any) => response.json() as ServiceProviderInterface[])
    );
  }

  getById(id: number): Observable<ServiceProviderInterface> {
    return this._http.get(constant.URL_SERVICE_PROVIDER + `/${id}`, this.getHeader())
      .map((res) => res.json() as ServiceProviderInterface)
      .catch(error => Observable.throw(error.json()));
  }

  getHistoryServiceProvider(idProvider: number): Observable<any[]> {
    return this._http.get(`${constant.URL_SERVICE_PROVIDER}/${idProvider}/history`, this.getHeader())
    .map((res: any) => res.json())
    .catch((error: any) => Observable.throw(error.json()));
  }

  nextBehaviorServiceProvId(id: number) {
    this.serviceProvId.next(id);
  }

  nextDataServiceProvider(data: ServiceProviderInterface) {
    this.dataServiceProviders.next(data);
  }

  post(data: ServiceProviderInterface) {
    const body = JSON.stringify(data);
    return this._http.post(constant.URL_SERVICE_PROVIDER, body, this.headerPost() ).
    pipe(
      map(( response: any) => response.json() as ResponseInterface)
    ).catch((error: any) => Observable.throw(error.json()));
  }

  postByPage(data: any) {
    const body = JSON.stringify(data);
    return this._http.post(`${constant.URL_SERVICE_PROVIDER}/List`, body, this.headerPost()).
      pipe(
        map((response: any) => response.json() as ResponseInterface)
      ).catch((error: any) => Observable.throw(error.json()));
  }

  put(data: ServiceProviderInterface) {
    const body = JSON.stringify(data);
    return this._http.put(constant.URL_SERVICE_PROVIDER, body, this.headerPost()).
    pipe(
      map(( response: any) => response.json() as ResponseInterface)
    ).catch((error: any) => Observable.throw(error.json()));
  }

  deleteProviderService(id: number) {
    return this._http.delete(`${constant.URL_SERVICE_PROVIDER}/${id}`, this.getHeader())
      .map(response => response.json());
  }

  putServiceProvidersMerge(data: MergeServiceProviderRequest) {
    return this._http.put(constant.URL_SERVICE_PROVIDER_MERGE, data, this.headerPost()).
      pipe(
        map((response: any) => response.json() as ResponseInterface)
      ).catch((error: any) => Observable.throw(error.json()));
  }

  setServiceProviders(serviceProviders: IServiceProvider[]) {
    this.serviceProviders.next(serviceProviders);
  }

  setCloseMergeServiProviders(isClose: boolean, refreshGrid: boolean, cleanServiceProviders) {
    this.closeModalMergeServiProviders.next({ isClose, refreshGrid });
    if (cleanServiceProviders) {
      this.setServiceProviders([]);
    }
  }
   setResetMergeSelection(): void {
    this.resetMergeSelectionSource.next(true);
  }
  notifyModalClosed() {
    this.modalClosedSource.next(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/service-provider.service.ts